export const UGC_CREATOR_TAG_NAME = 'UGC Creator'
export const UGC_CREATOR_TAG_KEY = 'ugc_creator'

export const isUgcCreatorTag = tag => tag?.system_key === UGC_CREATOR_TAG_KEY || tag?.name === UGC_CREATOR_TAG_NAME
